import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ArticlesWithLoadState } from '@shared/shared/interfaces/article.interfaces';
import { ArticlesReducersState } from './articles.state';

export const getArticlesState = createFeatureSelector<ArticlesReducersState>('articles');

export const getAllArticlesState = createSelector(
  getArticlesState,
  (state: ArticlesReducersState) => state.data.articles
);

export const getAllArticlesLoadingState = createSelector(
  getAllArticlesState,
  (state: ArticlesWithLoadState) => state.loading
);

export const getAllArticlesLoadedState = createSelector(
  getAllArticlesState,
  (state: ArticlesWithLoadState) => state.loaded
);

export const getArticleState = createSelector(getArticlesState, (state: ArticlesReducersState) => state.data.article);
